import React from 'react';
import { connect } from 'react-redux'
import { useState, useEffect } from 'react'
import Select from 'react-select';

function SelectRegion({ defaultValue, small, regions, onChange }) {
    const [selectRegions, set_selectRegions] = useState("")
    const [selected, setSelected] = useState(null)
    const colorStyles = {
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? "#FFEFCF" : "#fff",
            color: state.isSelected ? "#000" : "#000"
        })
    }
    
    const customStyles = {
        control: base => ({
            ...base,
            minHeight: 30,
            width: 206
        }),
        dropdownIndicator: base => ({
            ...base,
            padding: 4
        }),
        clearIndicator: base => ({
            ...base,
            padding: 4
        }),
        valueContainer: base => ({
            ...base,
            padding: '0px 6px'
        }),
        input: base => ({
            ...base,
            margin: 0,
            padding: 0
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? "#FFEFCF" : "#fff",
            color: state.isSelected ? "#000" : "#000"
        })
    };

    useEffect(() => {
        if (regions) {
            set_selectRegions(regions.map(i => {
                return {
                    value: i.id,
                    label: i.name
                }
            }).sort(function (a, b) {
                if (a.label.toLowerCase() > b.label.toLowerCase()) {
                    return 1;
                }
                if (a.label.toLowerCase() < b.label.toLowerCase()) {
                    return -1;
                }
                return 0;
            }));
        }
    }, [regions]);

    if (regions) {
        return (
            <Select
                noOptionsMessage={() => "Нет совпадений"}
                classNamePrefix="react-select"
                options={selectRegions}
                placeholder="Не выбран"
                name="regions"
                value={defaultValue ? [{ value: defaultValue.key, label: defaultValue.value }] :  null}
                styles={small ? customStyles : colorStyles}
                onChange={(value) => {
                    setSelected(value);
                    onChange({ key: value.value, value: value.label })
                }}
            />
        )
    } else {
        return (
            <div>...</div>
        )
    }
}
const mapStateToProps = state => ({
    regions: state.dictionary.regions,
})

export default connect(mapStateToProps)(SelectRegion)
